/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getError selector
 * @author Roland Scott
 * @module react-async-hook\api\selectors\get-error
 */

import { IAsyncState } from "../../types";
import { getError as internalGetError } from "../../internal/state/selectors";

/**
 * Return the the error value for the given execution
 * @param state The async state
 * @param id The ID of the execution to look at
 */
export function getError<TResult = any>(state: IAsyncState<TResult>, id: number): TResult | undefined {
	return internalGetError(state as any, id);
}
